var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7488 2.20235L2.74865 9.6993C1.67364 10.3212 1.77676 11.9118 2.92678 12.3837L6.49869 13.8618V16.4994C6.49869 17.9494 8.34871 18.5463 9.20497 17.3931L10.5737 15.5462L14.0707 16.99C14.255 17.065 14.4488 17.1025 14.6425 17.1025C14.8988 17.1025 15.1519 17.0369 15.38 16.9087C15.78 16.6837 16.0551 16.2837 16.1269 15.8306L17.9832 3.73049C18.1738 2.47736 16.8301 1.58047 15.7488 2.20235ZM7.99871 16.4994V14.4806L9.14247 14.9525L7.99871 16.4994ZM14.6425 15.6025L9.83623 13.6181L14.2175 7.29615C14.5519 6.81177 13.9207 6.24927 13.4769 6.63365L6.86745 12.3931L3.49866 10.9993L16.4988 3.49924L14.6425 15.6025Z",
    fill: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLine);
export default __webpack_public_path__ + "clientapp/media/telegram_line.8ca1e364.svg";
export { ForwardRef as ReactComponent };